/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponAssignmentStatus } from './CouponAssignmentStatus';
import {
    CouponAssignmentStatusFromJSON,
    CouponAssignmentStatusFromJSONTyped,
    CouponAssignmentStatusToJSON,
} from './CouponAssignmentStatus';

/**
 * 
 * @export
 * @interface CouponAssignmentWithPromotion
 */
export interface CouponAssignmentWithPromotion {
    /**
     * 
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    truncatedBarcode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CouponAssignmentWithPromotion
     */
    couponRedeemedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CouponAssignmentWithPromotion
     */
    couponExpiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CouponAssignmentWithPromotion
     */
    createdAt: Date;
    /**
     * 
     * @type {CouponAssignmentStatus}
     * @memberof CouponAssignmentWithPromotion
     */
    status: CouponAssignmentStatus;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    promotionId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    playerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    couponId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    templateImageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    promotionDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CouponAssignmentWithPromotion
     */
    promotionName: string;
}



/**
 * Check if a given object implements the CouponAssignmentWithPromotion interface.
 */
export function instanceOfCouponAssignmentWithPromotion(value: object): value is CouponAssignmentWithPromotion {
    if (!('couponExpiresAt' in value) || value['couponExpiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('promotionId' in value) || value['promotionId'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('couponId' in value) || value['couponId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('templateImageUrl' in value) || value['templateImageUrl'] === undefined) return false;
    if (!('promotionName' in value) || value['promotionName'] === undefined) return false;
    return true;
}

export function CouponAssignmentWithPromotionFromJSON(json: any): CouponAssignmentWithPromotion {
    return CouponAssignmentWithPromotionFromJSONTyped(json, false);
}

export function CouponAssignmentWithPromotionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponAssignmentWithPromotion {
    if (json == null) {
        return json;
    }
    return {
        
        'truncatedBarcode': json['truncatedBarcode'] == null ? undefined : json['truncatedBarcode'],
        'couponRedeemedAt': json['couponRedeemedAt'] == null ? undefined : (new Date(json['couponRedeemedAt'])),
        'couponExpiresAt': (new Date(json['couponExpiresAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'status': CouponAssignmentStatusFromJSON(json['status']),
        'promotionId': json['promotionId'],
        'playerId': json['playerId'],
        'couponId': json['couponId'],
        'customerId': json['customerId'],
        'id': json['id'],
        'templateImageUrl': json['templateImageUrl'],
        'promotionDescription': json['promotionDescription'] == null ? undefined : json['promotionDescription'],
        'promotionName': json['promotionName'],
    };
}

export function CouponAssignmentWithPromotionToJSON(value?: CouponAssignmentWithPromotion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'truncatedBarcode': value['truncatedBarcode'],
        'couponRedeemedAt': value['couponRedeemedAt'] == null ? undefined : ((value['couponRedeemedAt'] as any).toISOString()),
        'couponExpiresAt': ((value['couponExpiresAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'status': CouponAssignmentStatusToJSON(value['status']),
        'promotionId': value['promotionId'],
        'playerId': value['playerId'],
        'couponId': value['couponId'],
        'customerId': value['customerId'],
        'id': value['id'],
        'templateImageUrl': value['templateImageUrl'],
        'promotionDescription': value['promotionDescription'],
        'promotionName': value['promotionName'],
    };
}

